import React, { useState } from 'react';
import LedInfoModal from './LedInfoModal';

interface Props {
  children: React.ReactNode;
}

const StepTitleWithInfo: React.FC<Props> = ({ children }) => {
  const [showLedInfo, setShowLedInfo] = useState(false);

  return (
    <>
      <div className="dcf-step-title-row">
        {children}
        <button
          type="button"
          className="dcf-step-title__info-btn"
          onClick={() => setShowLedInfo(true)}
          aria-label="LED indicator info"
        >
          <span className="dcf-step-title__info-icon">i</span>
        </button>
      </div>
      <LedInfoModal
        isOpen={showLedInfo}
        onClose={() => setShowLedInfo(false)}
      />
    </>
  );
};

export default StepTitleWithInfo;
